import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['name', 'phone', 'email', 'city']

  redirect(e) {
    const city = e.currentTarget.value
    const url = `${city}/orders/leadads`
    const params = {
      name: this.nameTarget.value,
      email: this.emailTarget.value,
      phone: this.phoneTarget.value == '+7(___)___-__-__' ? '' : this.phoneTarget.value,
    }
    let attrs = []
    for (const key in params) {
      if (params[key]) {
        attrs.push(`${key}=${params[key]}`)
      }
    }
    window.location = `${url}?${attrs.join('&')}`
  }
}
